export enum PlanInterval {
  Year = 'year',
  Month = 'month',
}

export type Plan = {
  amount: number
  interval: PlanInterval
}
